// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__fzDQN","title":"Info_title__2Zv9P","links":"Info_links__39TSJ","link":"Info_link__2QpWY","logo":"Info_logo__1oTxK"};